export default {"src":"/_next/static/media/share_link.08022c06.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};